/** A date without time: "1 juni 2020". For governance dates that are day-granular. */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("sv-SE", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/** Compact Swedish timestamps for lists: "idag 13:02", "igår 09:41", "12 aug. 13:02". */
export function formatWhen(iso: string): string {
  const then = new Date(iso);
  const now = new Date();
  const time = then.toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit" });
  if (then.toDateString() === now.toDateString()) {
    return `idag ${time}`;
  }
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (then.toDateString() === yesterday.toDateString()) {
    return `igår ${time}`;
  }
  return `${then.toLocaleDateString("sv-SE", { day: "numeric", month: "short" })} ${time}`;
}
